import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { IonSlides } from '@ionic/angular';
import { ConexionService } from 'src/app/servicios/conexion.service';
import { UtilidadesService } from 'src/app/servicios/utilidades.service';

@Component({
  selector: 'app-config-galeria-actividad',
  templateUrl: './config-galeria-actividad.component.html',
  styleUrls: ['./config-galeria-actividad.component.scss'],
})
export class ConfigGaleriaActividadComponent implements OnInit {
  @Input() Fotos = [];
  @Input() Titulo = "";
  @Input() Portada = 0;
  @Output() Archivo = new EventEmitter()
  @Output() MuchosArchivo = new EventEmitter()
  @Output() CambioPortada = new EventEmitter()
  @Output() Orden = new EventEmitter()
  @Output() Eliminar = new EventEmitter()
  @Output() Visibilidad = new EventEmitter()
  @Output() Recargar = new EventEmitter()
  @Output() VisibilidadSeleccionados = new EventEmitter()

  Tipo = "image/*"

  constructor(private conexion: ConexionService, public utilidades: UtilidadesService) { }

  @ViewChild('mySlider') slides: IonSlides;

  ngOnInit() {
    this.utilidades.tetminoSubida$.subscribe(resp => {
      this.Recargar.emit()
    })

    setTimeout(() => {
      for (let i in this.Fotos) {
        this.Fotos[i].checked = false
        this.Fotos[i].Orden = Number(i)
      }
      console.log(this.Fotos)
    }, 150);
  }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    setTimeout(() => {
      for (let i in this.Fotos) {
        this.Fotos[i].checked = false
        this.Fotos[i].Orden = Number(i)
      }
      console.log(this.Fotos)
    }, 150);
  }

  //Muesta el slide1 de Actividades
  goToSlide1() {
    this.slides.slideTo(0, 500);
  }

  //Hacer funcionar la subida, eliminar y ordenar
  SubirFoto() {
    let foto = document.getElementById("foto")["files"]
    let t = ""
    if (this.Tipo == "image/*") {
      t = "Foto"
    } else {
      t = "Video"
    }
    this.Archivo.emit({ Foto: foto, Tipo: t })

  }


  SubirMuchasFoto() {
    let foto = document.getElementById("foto")["files"]
    let t = ""
    let d = []
    if (this.Tipo == "image/*") {
      t = "Foto"
    } else {
      t = "Video"
    }

    this.MuchosArchivo.emit({ Foto: foto, Tipo: t })

  }

  reorderItems(ev) {
    const itemMove = this.Fotos.splice(ev.detail.from, 1)[0];
    this.Fotos.splice(ev.detail.to, 0, itemMove);
    ev.detail.complete();

    this.Orden.emit(this.Fotos)
  }

  ReordenarVarios() {
    console.log(this.Fotos)
    let arr = JSON.parse(JSON.stringify(this.Fotos))
    for (let i = 0; i < arr.length; i++) {
      for (let j = i; j < arr.length; j++) {
        if (arr[i].Orden > arr[j].Orden) {
          let pos = arr[i]
          arr[i] = arr[j]
          arr[j] = pos
        }
      }
    }

    for (let i in this.Fotos) {
      this.Fotos[i].Orden = Number(i)
    }

    this.Fotos = arr
  }

  EliminarSeleccionados() {
    let time = 150
    if (!confirm("¿Desea eliminar estas multimedias?")) {
      return 0;
    }
    for (let i of this.Fotos) {
      if (i.checked) {
        time += time + 50
        setTimeout(() => {
          this.EliminarMedia(i, true)
        }, time);
      }
    }
  }

  cambiarVisibilidadSeleccionados(visibilidad) {

    let ids_visibilidad = {ids: [], visibilidad: visibilidad}
    for (let i of this.Fotos) {
      if (i.checked) {
          i.Visible = visibilidad
          ids_visibilidad.ids.push(String(i.Id))
      }
    }
    
    this.CambiarVisibilidadSeleccionados(ids_visibilidad)
  }

  VerificarTodosCheck() {
    for (let i of this.Fotos) {
      if (!i.checked) {
        return false
      }
    }

    return true
  }

  VerificarSiHayCheck() {
    if(this.VerificarTodosCheck()){
      return false
    }
    for (let i of this.Fotos) {
      if (i.checked) {
        return true
      }
    }

    return false
  }

  Check(ev) {
    setTimeout(() => {
      let val = ev.target.checked
      for (let i of this.Fotos) {
        i.checked = val
      }
    }, 10);
  }

  EliminarMedia(media, confirmacion = false) {
    this.Eliminar.emit({ media, confirmacion })
  }

  CambiarVisibilidad(media, ban = false) {
    media.ban = ban
    this.Visibilidad.emit(media)
  }

  CambiarVisibilidadSeleccionados(ids_visibilidad) {
    this.VisibilidadSeleccionados.emit(ids_visibilidad)
  }


  CambiarPortadaActividad(media) {
    this.CambioPortada.emit(media)
    this.Portada = media.IdThum
  }


}
